import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  profileInformationContainer: {
    padding: '0 24px',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '24px',
  },
  requiredMark: {
    color: STYLE.COLOR.ERROR,
    paddingLeft: '3px',
  },
  divider: {
    height: '1px',
    backgroundColor: '#EAEAEA',
    width: '100%',
    marginTop: '32px' + ' !important',
    marginBottom: '32px' + ' !important',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '32px',
  },
  saveButton: {
    minWidth: '160px !important',
  },
  profilePicContainer: {
    height: 96,
    width: 96,
    borderRadius: '50%',
    backgroundColor: STYLE.COLOR.WARNING_NOTE,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
    cursor: 'pointer',
    marginBottom: 8,
  },
  profileImage: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  profilePicUploadingOverlay: {
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    backgroundColor: STYLE.COLOR.BACKGROUND_OVERLAY,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  cameraIconContainer: {
    position: 'absolute',
    bottom: -24,
    right: -16,
  },
  profilePicText: {
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '32px',
    color: STYLE.COLOR.TEXT4,
  },
  profilePicErrorText: {
    fontSize: '12px',
    fontWeight: 400,
    color: STYLE.COLOR.ERROR,
    margin: '4px 0 0 0',
  },
  profilePicMainContainer: {
    marginBottom: '32px',
  },
  addImageContainer: {
    marginTop: '24px',
  },
  galleryDialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      maxHeight: '80vh',
    },
  },
  galleryDialogTitle: {
    position: 'relative',
    display: 'flex',
    padding: '20px 48px',
    borderBottom: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '140%',
    letterSpacing: 0,
    color: STYLE.COLOR.TEXT1,
  },
  galleryDialogCloseButton: {
    position: 'absolute !important' as any,
    top: 12,
    right: 12,
  },
  galleryContent: {
    padding: '16px !important',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  galleryItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px',
    gap: '16px',
    borderRadius: '16px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    boxShadow: '0px 4px 20px 0px rgba(0, 58, 87, 0.05)',
    backgroundColor: STYLE.COLOR.WHITE,
    position: 'relative',
  },
  galleryThumbnail: {
    width: 80,
    height: 80,
    borderRadius: '8px',
    objectFit: 'cover' as any,
    display: 'block',
    flexShrink: 0,
  },
  galleryThumbnailFallback: {
    width: 80,
    height: 80,
    borderRadius: '8px',
    flexShrink: 0,
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
  },
  galleryItemInfo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  galleryItemName: {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '24px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
  },
  galleryCurrentBadge: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginLeft: '8px',
    padding: '2px 8px',
    borderRadius: '12px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '16px',
    backgroundColor: STYLE.COLOR.LIGHT_BLUE,
    color: STYLE.COLOR.ACCENT_PRIMARY,
  },
  galleryItemMeta: {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '19px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
  },
  galleryExpandButton: {
    alignSelf: 'flex-start !important' as any,
    padding: '4px !important',
    flexShrink: 0,
  },
  galleryExpandIcon: {
    // width: 20,
    // height: 20,
  },
  galleryEmptyText: {
    textAlign: 'center',
    color: STYLE.COLOR.TEXT4,
    padding: '40px 20px',
    fontSize: '14px',
    margin: 0,
  },
  previewDialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      backgroundColor: STYLE.COLOR.BLACK,
    },
  },
  previewDialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px 12px 20px',
    backgroundColor: STYLE.COLOR.BLACK,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '140%',
    letterSpacing: 0,
    color: STYLE.COLOR.WHITE,
  },
  previewDialogCloseButton: {
    color: `${STYLE.COLOR.WHITE} !important`,
  },
  previewContent: {
    padding: '0 !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: STYLE.COLOR.BLACK,
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '80vh',
    objectFit: 'contain',
    display: 'block',
  },
  previewImageFallback: {
    width: '100%',
    minHeight: '240px',
    backgroundColor: STYLE.COLOR.BLACK,
  },
  profilePicMenu: {
    '& .MuiPaper-root': {
      borderRadius: '12px',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      padding: '12px',
      boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
      minWidth: '200px',
      marginLeft: '-30px !important',
    },
    '& .MuiList-root': {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
  },
  profilePicMenuItem: {
    padding: '8px !important',
    gap: '8px',
    borderRadius: '8px !important',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    '&:hover': {
      backgroundColor: `${STYLE.COLOR.BACKGROUND_LIGHT} !important`,
    },
    '& svg': {
      width: 18,
      height: 18,
      flexShrink: 0,
    },
  },
  genderParent: {
    width: '100%',
  },
  genderContainer: {
    marginTop: '0px !important',
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '8px',
  },
  otherTradeInput: {
    marginTop: '16px',
  },
  addTradeButton: {
    marginTop: '16px',
    marginBottom: '24px',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    padding: 0,
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 0',
  },
  galleryDialogCloseIcon: {
    width: 16,
    height: 16,
  },
}));
